import { CdToastStack } from '@ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { dismissToast, selectToasts } from '@/shared/toast/toastSlice';

/** Renders the global toast stack from Redux. Mounted once in AppProviders. */
export const ToastHost = () => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();
  const toasts = useAppSelector(selectToasts);

  return (
    <CdToastStack
      toasts={toasts.map(({ createdAt, ...toast }) => ({
        ...toast,
        caption: format(createdAt, 'HH:mm:ss'),
      }))}
      onDismiss={(id) => dispatch(dismissToast(id))}
      labels={{ close: t('toast.close') }}
    />
  );
};
